document.addEventListener("DOMContentLoaded", function() {

	// nastaveni swiperu pro prahu a okoli
	(function () {
		let swiperSelector = document.querySelector('.JS-slider');
		if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
			return;

		let swiperDetail3 = new Swiper(swiperSelector, {
			slidesPerView: 1,
			spaceBetween: 0,
			//autoplay: true,
			loop: true,

		});
	}());


	var oblastiMapy = document.getElementsByClassName("JS-oblast-mapa");

	for (var i=0; i < oblastiMapy.length; i++) {
		// On mouse over.
		oblastiMapy[i].addEventListener("mouseover", function () {
			this.classList.add("active");
			var numberId = this.getAttribute('id').charAt(7);
			var id = ('#oblast-' + numberId);
			document.querySelector(id).classList.add('active');

		});
		// On mouse out.
		oblastiMapy[i].addEventListener("mouseout", function () {
			// Change back to original color.
			this.classList.remove("active");
			var numberId = this.getAttribute('id').charAt(7);
			var id = ('#oblast-' + numberId);
			document.querySelector(id).classList.remove('active');
		});
	}

	var oblastiTitleMapy = document.getElementsByClassName("JS-title-oblast");

	for (var i=0; i < oblastiTitleMapy.length; i++) {
		// On mouse over.
		oblastiTitleMapy[i].addEventListener("mouseover", function () {
			var id = this.id + '-mapa';
			document.getElementById(id).classList.add("active");

		});
		// On mouse out.
		oblastiTitleMapy[i].addEventListener("mouseout", function () {
			var id = this.id + '-mapa';
			document.getElementById(id).classList.remove("active");
		});
	}

});

